import { render, staticRenderFns } from "./SuccessInviteBlock.vue?vue&type=template&id=71b02287&scoped=true&"
import script from "./SuccessInviteBlock.vue?vue&type=script&lang=js&"
export * from "./SuccessInviteBlock.vue?vue&type=script&lang=js&"
import style0 from "./SuccessInviteBlock.vue?vue&type=style&index=0&id=71b02287&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b02287",
  null
  
)

export default component.exports